import { useCallback, useMemo } from 'react'
import NSWAgreementSignatureStageSteps from 'pages/campaigns/components/campaignTasks/AgreementCompliance/NSW/NSWAgreementSignatureStageSteps'
import { BaseComplianceModalProps } from '../BaseComplianceModalProps'

const NswAgreementCommissionPage = ({
  task,
  toggleTaskStep,
}: BaseComplianceModalProps) => {
  const taskSteps = useMemo(() => task.taskSteps ?? [], [task.taskSteps])

  const updateTaskStep = useCallback(
    (step: { order?: number }, isChecked: boolean) => {
      toggleTaskStep(step.order ?? 0, isChecked)
    },
    [toggleTaskStep]
  )

  return (
    <NSWAgreementSignatureStageSteps
      tasksStage={taskSteps}
      updateTaskStep={updateTaskStep}
    />
  )
}

export default NswAgreementCommissionPage
